import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CardStatusRequest } from "../../models/request/card-status/CardStatusRequest";
import { Observable } from "rxjs";
import { CardStatusResponse } from "../../models/response/card-status/CardStatusResponse";
import { CardNumbersResponse } from "../../models/response/card-status/CardNumbersResponse";

@Injectable({
  providedIn: 'root'
})
export class CardStatusService {

  private checkCardStatusUrl = `${environment.serverUrl}/checkcardstatus`;
  private checkCardTypeEligibilityUrl = `${environment.serverUrl}/cardtypeinquiry`;

  constructor(private http: HttpClient) {
  }

  checkCardStatus(cardstatus: CardStatusRequest): Observable<CardStatusResponse> {
    const httpOptions = {
      headers: new HttpHeaders(
        { 'Content-Type': 'application/json' }
      )
    }
    return this.http.post<CardStatusResponse>(this.checkCardStatusUrl, cardstatus, httpOptions);
  }

  checkCardTypeEligibility(): Observable<CardNumbersResponse> {
    const httpOptions = {
      headers: new HttpHeaders(
        { 'Content-Type': 'application/json' }
      ),
    }
    return this.http.get<CardNumbersResponse>(this.checkCardTypeEligibilityUrl, httpOptions);
  }
}
